import * as React from "react";
export const GraphLineIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg data-name="Capa 1" viewBox="0 0 509.632 402.522" {...props}>
    <path d="M495.111 4.522c-14-9-32-4-41 10l-141 230-53-69c-13-17-38-16-49 2l-61 102-28-37c-13-17-39-16-50 2l-68 113c-11 19 1 45 25 45a31.43 31.43 0 0026-14l45-75 28 38c13 17 39 16 50-2l61-103 53 69c13 17 38 15 49-2l164-268c9-14 4-32-10-41z" />
  </svg>
);
